module.exports = __webpack_public_path__ + "static/media/open-lootbox-arrow.e13a5233.png";